import React from "react"
import { useScheduledTaskReportExportContext } from "contexts/ScheduledTaskReportExportContext"
import { Checkbox } from "shared/checkboxes"
import { RadioButton } from "shared/inputs"
import MassSelection from "shared/MassSelection"

// Choosing between every form and a named set, rather than leaving an unchecked list to mean
// everything, so that a schedule which should pick up forms added later says so.
const ScheduledTaskReportExportSubmittableFormFilter = () => {
  const {
    chooseAllForms,
    chooseSpecificForms,
    deselectAllFormSlugs,
    includeAllForms,
    isFormSlugSelected,
    noSubmittableFormIncluded,
    selectAllFormSlugs,
    submittableForms,
    toggleIncludedFormSlug,
  } = useScheduledTaskReportExportContext()

  return (
    <>
      <RadioButton
        checked={includeAllForms}
        className="mb-4 last:mb-0"
        label="Include tasks from all current and future forms"
        name="choose-all-current-and-future-forms"
        onChange={chooseAllForms}
        value={includeAllForms}
      />

      <RadioButton
        checked={!includeAllForms}
        className="mb-4 last:mb-0"
        label="Include tasks from specific forms"
        name="choose-specific-forms"
        onChange={chooseSpecificForms}
        value={!includeAllForms}
      />

      {
        !includeAllForms && (
          <div className="mt-8">
            <div className="mb-2">Forms to include:</div>
            <MassSelection className="mb-5" deselectAll={deselectAllFormSlugs} selectAll={selectAllFormSlugs} />
            <div className="space-y-2">
              {
                submittableForms.map(({ slug, title }) => {
                  const optionIdentifier = `scheduled-task-report-export-submittable-form-${slug}`

                  return (
                    <div className="flex items-center" key={slug}>
                      <Checkbox
                        className="mr-4"
                        onChange={() => toggleIncludedFormSlug(slug)}
                        uuid={optionIdentifier}
                        value={isFormSlugSelected(slug)}
                      />
                      <label className="cursor-pointer" htmlFor={optionIdentifier}>
                        {title}
                      </label>
                    </div>
                  )
                })
              }
            </div>
            {
              noSubmittableFormIncluded && (
                <p className="text-xs text-error mt-2">
                  At least one form must be selected.
                </p>
              )
            }
          </div>
        )
      }
    </>
  )
}

export default ScheduledTaskReportExportSubmittableFormFilter
